import React from 'react'
import { apiClient } from '../../Module/API/Client'
import {
  MISSION_STATUS_ENUM,
  STATUS_AVAILABLE,
  STATUS_CAMPAIGN_ENUM_ACTIVE,
} from '../../shared/constants'

export const confirmationModalBody = () => {
  return (
    <section className="redux-modal">
      <article>
        <p>
          If rating features are enabled for your country, missions will
          gradually become available over the next 90 minutes, with the
          highest-rated brand ambassadors seeing them first.
        </p>
      </article>
    </section>
  )
}

export const getShowDeleteAllNonStartedModalText = isAnyBooked =>
  isAnyBooked ? (
    <div>
      <p>
        All BAs and Spies who have booked missions will be un-booked and will a
        receive notification.
      </p>
      <p>All available and draft missions will then be permanently deleted.</p>
      <p>
        Please select a reason to be displayed to BAs who are being unbooked.
      </p>
    </div>
  ) : (
    'All available and draft missions will be permanently deleted'
  )

export const onPublishDraftMissions = ({
  campaign,
  missions,
  showReduxModal,
  updateData,
}) => {
  if (campaign.status != STATUS_CAMPAIGN_ENUM_ACTIVE) {
    return showReduxModal({
      title: 'Draft campaign',
      children:
        'Missions are allowed to be published only if campaign is active.',
      confirmLabel: 'OK',
      hideCancel: true,
    })
  }

  const totalMissionsToPublish = missions.filter(
    mission => mission.status == MISSION_STATUS_ENUM.DRAFT,
  ).length

  if (totalMissionsToPublish < 1) {
    return showReduxModal({
      title: 'No missions to publish',
      confirmLabel: 'OK',
      hideCancel: true,
    })
  }

  showReduxModal({
    title: `Publishing ${totalMissionsToPublish} Missions`,
    onConfirm: async () => {
      const missionUpdates = missions
        .filter(m => {
          return m.status === MISSION_STATUS_ENUM.DRAFT
        })
        .map(m => {
          return {
            id: m.id,
            status: STATUS_AVAILABLE,
          }
        })
      const updatedMissionsIds = missionUpdates.map(({ id }) => id)

      const req = await apiClient.publishMissions(missionUpdates)

      const res = await req.json()

      updateData(missions =>
        missions.map(mission =>
          updatedMissionsIds.includes(mission.id)
            ? { ...mission, status: MISSION_STATUS_ENUM.AVAILABLE }
            : mission,
        ),
      )

      if (res.message) {
        // Rollback On Error
        updateData(missions =>
          missions.map(mission =>
            updatedMissionsIds.includes(mission.id)
              ? { ...mission, status: MISSION_STATUS_ENUM.DRAFT }
              : mission,
          ),
        )
        showReduxModal({
          title: 'Cannot publish',
          children: res.message,
          confirmLabel: 'OK',
          hideCancel: true,
        })
      }
      // We dont set "onConfirm: publishMissionsHandler" directly in order to not block UI while loading
      // Modal hides after confirm
    },
    children: confirmationModalBody(),
    confirmLabel: `Publish ${totalMissionsToPublish} missions`,
  })
}



// WEBPACK FOOTER //
// ./src/Components/MissionsControls/utils.js